
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';

export default defineComponent({
  name: 'RcsOnboardingNav',

  components: { Button },

  props: {
    showBack: { type: Boolean, default: false },
    showNext: { type: Boolean, default: false },
    showSubmit: { type: Boolean, default: false },
    canGoNext: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    nextLabel: { type: String, default: '' },
  },

  emits: ['back', 'next', 'submit'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
